// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gridHeader {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
}
.gridHeader button {
  margin-right: 15px;
}
.gridHeader button .fas {
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/construction/contracts/change-orders/contract-change-orders.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,qBAAA;AACJ;AAAI;EACI,kBAAA;AAER;AADQ;EACI,iBAAA;AAGZ","sourcesContent":[".gridHeader{\n    width: 100%;\n    display: flex;\n    flex-flow: row nowrap;\n    button{\n        margin-right:15px;\n        .fas{\n            margin-right:8px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
